import {PlayerColor} from '@colonist/game-states'

export const getColorFromPlayerColor = (playerColor: PlayerColor): string => {
    const COLOR_MAP: Record<PlayerColor, string> = {
        [PlayerColor.None]: '#00000000', // None default to transparent
        [PlayerColor.Red]: '#CF4449',
        [PlayerColor.Blue]: '#285FBD',
        [PlayerColor.Orange]: '#D67236',
        [PlayerColor.Green]: '#338F1D',
        [PlayerColor.Black]: '#3D3D3D',
        [PlayerColor.Bronze]: '#804640',
        [PlayerColor.Silver]: '#878787',
        [PlayerColor.Gold]: '#C79A3E',
        [PlayerColor.White]: '#D3D3D3',
        [PlayerColor.Purple]: '#72559E',
        [PlayerColor.MysticBlue]: '#4FA8C4',
        [PlayerColor.Pink]: '#D66B87',
    }

    return COLOR_MAP[playerColor]
}

export const getVPCircleColor = (playerColor: PlayerColor): string => {
    const VP_CIRCLE_COLOR_MAP: Record<PlayerColor, string> = {
        [PlayerColor.None]: '#00000000',
        [PlayerColor.Red]: '#C42E2A',
        [PlayerColor.Blue]: '#1B50BC',
        [PlayerColor.Orange]: '#BD5F28',
        [PlayerColor.Green]: '#0A8C00',
        [PlayerColor.Black]: '#373638',
        [PlayerColor.Bronze]: '#85341E',
        [PlayerColor.Silver]: '#7A7C7E',
        [PlayerColor.Gold]: '#B6940C',
        [PlayerColor.White]: '#C6C7C8',
        [PlayerColor.Purple]: '#6B3981',
        [PlayerColor.MysticBlue]: '#41ACB9',
        [PlayerColor.Pink]: '#CB6279',
    }

    return VP_CIRCLE_COLOR_MAP[playerColor]
}
